import './App.css';
import {useEffect} from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import Admin from "./components/Admin/Admin";
import LPRoute from "./utls/LPRoute";
import Terms from "./components/Terms/Terms";
import WebinarEmailReport from "./components/WebinarEmailReport/WebinarEmailReport";
import SiteFooter from "./components/SiteFooter/SiteFooter";

function ApiDevRedirect() {
    useEffect(() => {
        const apiBaseUrl =
            process.env.REACT_APP_API_BASE_URL ||
            (window.location.hostname === "localhost" ? "http://localhost:8000" : window.location.origin);
        const targetUrl = `${apiBaseUrl}${window.location.pathname}${window.location.search}${window.location.hash}`;

        if (targetUrl !== window.location.href) {
            window.location.replace(targetUrl);
        }
    }, []);

    return <main style={{padding: "32px", textAlign: "center"}}>Redirecting to API...</main>;
}

function App() {
    const location = useLocation();
    const isWebinarEmailReport = /^\/[^/]+\/emails\/?$/.test(location.pathname);
    const appClassName = location.pathname.startsWith("/admin") ||
        isWebinarEmailReport
        ? "App App--admin"
        : location.pathname === "/terms"
            ? "App App--legal"
            : "App";

    return (
    <div className={appClassName}>
        <Routes>
            <Route path="/admin" element={<Admin/>}/>
            <Route path="/api/*" element={<ApiDevRedirect/>}/>
            <Route path="/terms" element={<Terms/>}/>
            <Route path="/:webinarIdentifier/emails" element={<WebinarEmailReport/>}/>
            <Route path="/" element={<LPRoute/>}/>
            <Route path="/:slug" element={<LPRoute/>}/>
        </Routes>
        {!location.pathname.startsWith("/api") && <SiteFooter/>}
    </div>
  );
}

export default App;
